import { SkeletonProductSection } from '../../components/skeletons/SkeletonSection';
import { ProductSection } from './ProductSection';
import { useFormattedPosthumousRoutes } from './home.store';

export const PosthumousSection = () => {
  const { items, product, isLoading } = useFormattedPosthumousRoutes();

  if (isLoading) {
    return <SkeletonProductSection />;
  }

  return (
    <ProductSection color={product.color} product={product} items={items} />
  );
};
